import { Pressable } from "react-native";
import { View, Text } from "@src/components";
import { useUnistyles } from "react-native-unistyles";

export interface FilterPillProps {
  /** The text to display in the pill */
  label: string;
  /** Whether the pill is currently active/selected */
  isActive: boolean;
  /** Callback when the pill is pressed */
  onPress: () => void;
  /** Whether the pill is disabled */
  disabled?: boolean;
}

/**
 * A pill-shaped toggle button used for filtering content.
 * Displays with a border when inactive, and filled background when active.
 */
export function FilterPill({ label, isActive, onPress, disabled = false }: FilterPillProps) {
  const { theme } = useUnistyles();

  return (
    <Pressable onPress={onPress} disabled={disabled}>
      <View
        px="xl"
        py="sm"
        rounded={theme.spacing.md}
        style={{
          backgroundColor: isActive ? theme.colors.muted : "transparent",
          borderWidth: 1,
          borderColor: theme.colors.border,
          opacity: disabled ? 0.5 : 1,
        }}
      >
        <Text textStyle="sm/medium" color={isActive ? "text" : "textMuted"}>
          {label}
        </Text>
      </View>
    </Pressable>
  );
}
